import React, { useContext, useEffect, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ConfigContext from '../../utils/ConfigContext/ConfigContext';
import { FloorPlanPropTypes, FloorPlanDefaultProps } from '../../utils/DrupalEntityTypes/FloorPlan/FloorPlanPropTypes';
import { sanitizeStingALaDrupal } from '../../utils/common';

import { ReactComponent as DownloadIcon } from '../../SVGAssets/DownloadIcon.svg';

import './FloorPlanImagesWidgetButtons.scss';

const FloorPlanImagesWidgetButtons = ( {
  activeFloorPlan,
  setActiveFloorPlan,
  data
} ) => {
  const [ showDownload, setShowDownload ] = useState( false );
  const [ sanitizedTitle, setSanitizedTitle ] = useState('none');

  const { windowWidth, settings } = useContext( ConfigContext );
  const {
    platform,
    urlSlug,
  } = settings;

  const {
    uuid,
    drupalNid,
    title,
    twoD,
    threeD,
    downloadablePdf,
  } = data;

  const threeDSrc = threeD?.modal;
  const twoDSrc = twoD?.modal;

  useEffect( () => {
    if ( platform === 'page' ) {
      setShowDownload( true );
    }
  }, [ platform ] );

  // Sanitize fp title for url.
  useEffect(() => {
    if ( title ) {
      const rawSanitizedTitle = sanitizeStingALaDrupal( title );
      setSanitizedTitle( rawSanitizedTitle );
    }
  }, [ title ])

  const handleFpToggle = () => {
    setActiveFloorPlan( !activeFloorPlan );
  };

  const handleDownload = () => {
    const link = document.createElement( 'a' );
    link.href = downloadablePdf;
    link.target = '_blank';
    document.body.appendChild( link );
    link.click();
    document.body.removeChild( link );
    // @TODO: Add Fathom event.
  };

  return (
    <div className="floorPlanImagesWidget__buttons">

      { twoDSrc && threeDSrc && ( windowWidth >= 768 ) && (
        <>
          <button
            type="button"
            className={
              classnames( 'floorPlanImagesWidget__button', {
                'floorPlanImagesWidget__button--active': !activeFloorPlan,
              } )
            }
            onClick={handleFpToggle}
          >
            3D
          </button>

          <button
            type="button"
            className={
              classnames( 'floorPlanImagesWidget__button', {
                'floorPlanImagesWidget__button--active': activeFloorPlan,
              } )
            }
            onClick={handleFpToggle}
          >
            2D
          </button>
        </>
      )}

      { showDownload && downloadablePdf && (
        <button
          type="button"
          onClick={handleDownload}
          className="floorPlanImagesWidget__button floorPlanImagesWidget__button--download"
        >
          <DownloadIcon />
          <span>Download Floor Plan</span>
        </button>
      )}

      { showDownload && (
        // We don't actally needs the uuid or drupal resident id to render the print page, but we
        // include it for analytics.
        <Link
          className="floorPlanImagesWidget__button"
          target="_blank"
          to={ `/${urlSlug}/floor-plan/${sanitizedTitle}/${drupalNid}?mode=print` }
        >
          Print
        </Link>
      )}

    </div>
  );
};

FloorPlanImagesWidgetButtons.propTypes = {
  activeFloorPlan: PropTypes.bool.isRequired,
  setActiveFloorPlan: PropTypes.func.isRequired,
  data: FloorPlanPropTypes.data,
};

FloorPlanImagesWidgetButtons.defaultProps = {
 data: FloorPlanDefaultProps.data,
};

export default FloorPlanImagesWidgetButtons;
